import { useEffect } from 'react';

/**
 * LegalRedirect - Redirects to static HTML legal pages
 * Used for /privacy and /terms routes to redirect to static HTML files
 * that Google can crawl for OAuth verification
 */
export function LegalRedirect({ to }) {
    useEffect(() => {
        // Redirect to the static HTML file
        window.location.href = to;
    }, [to]);

    // Show loading while redirecting
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Redirecting...</p>
            </div>
        </div>
    );
}